import ColorContrastChecker from "color-contrast-checker";

var PlistParser = require('plist-parser');
var plist = require('plist');

var LocalizationManager = require('./LocalizationManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var PlatformConstants = require('./constants/PlatformConstants');
var DeepLinkManager = require('./wrappers/DeepLinkManager');
var NetworkManager = require('./NetworkManager');
var BundleVersion = require('./BundleVersion');
var EventEmitter = require('eventemitter3');
var DeviceInfo = require('react-native-device-info');
var PushManager = require('./wrappers/PushManager-wrapper');

import DBManager from './DBManager';
var AnalyticsManager = require('./AnalyticsManager');

var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var {
  StatusBar,
  Platform,
  NativeModules,
  DeviceEventEmitter,
  AppState,
  Linking
} = ReactNative;

var AccessibilityManager = NativeModules.AccessibilityManager;
var AmazonSNSManager = NativeModules.RNAmazonSNSManager;
var RNReUpUpdater = NativeModules.RNReUpUpdater;

var RNFS = require('./wrappers/react-native-fs');

var RNZipManager = NativeModules.RNZipManager;

var PushNotification = require('./wrappers/react-native-push-notification');

var DEFAULT_USER = null;
if( false )
{
  DEFAULT_USER = {
    DollarsPerPoint:1,
    UserID: 1,
    UserName: "kjregan10@gmail.com",
    Password: "12341234",
    Hash: "asdf",
    FirstName: "Kelsey",
    LastName: "Regan",
    DOB: "",
    Admin: 0,
    Credit: 100,
    Points: 1100,
    QRCode_Pay: "QRCode_Pay",
    QRCode_Redeem: "QRCode_Redeem",
    STRIPE_lastFour: "",
    STRIPE_paymentType: "",
    STRIPE_pubKey: "",
    PayPalClientID: "",
    PayPal_Environment: "PayPal_Environment",
    CardType: "0",
    PaymentInfo: "PaymentInfo",
    PayPal_ClientID: "PayPal_ClientID",
    DirtyPassword: 0,
    CC_Gateway_Primary: "CC_Gateway_Primary",
    PayMode: 0,
    PhoneNumber: "",
    ShowPhoneNumber: 0,
    RequirePhoneForPurchase: 0,
    RequirePhoneForRewards: 0,
    RequirePostalCode: 0,
    RequirePhoneForPaymentTypes: 0,
    HasPassword: 1,
    HasFacebook: 0,
    DefaultDistance: "km",
    UsePhoneLoyalty: 0,
    TotalCreditUsedAtScanner: 100,
    TotalPointsUsedAtScanner: 100,
    TotalPointsAddedAtScanner: 100,
  }
}

function getParameterByName(url, name)
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

function calcLuminance(hex)
{
  var r = parseInt("0x" + hex.substring(0,2));
  var g = parseInt("0x" + hex.substring(2,4));
  var b = parseInt("0x" + hex.substring(4,6));

  return ((r*0.299 + g*0.587 + b*0.114) / parseFloat(256));
}

function shadeBlend(p,c0,c1)
{
    var n=p<0?p*-1:p,u=Math.round,w=parseInt;
    if(c0.length>7){
        var f=c0.split(","),t=(c1?c1:p<0?"rgb(0,0,0)":"rgb(255,255,255)").split(","),R=w(f[0].slice(4)),G=w(f[1]),B=w(f[2]);
        return "rgb("+(u((w(t[0].slice(4))-R)*n)+R)+","+(u((w(t[1])-G)*n)+G)+","+(u((w(t[2])-B)*n)+B)+")"
    }else{
        var f=w(c0.slice(1),16),t=w((c1?c1:p<0?"#000000":"#FFFFFF").slice(1),16),R1=f>>16,G1=f>>8&0x00FF,B1=f&0x0000FF;
        return "#"+(0x1000000+(u(((t>>16)-R1)*n)+R1)*0x10000+(u(((t>>8&0x00FF)-G1)*n)+G1)*0x100+(u(((t&0x0000FF)-B1)*n)+B1)).toString(16).slice(1)
    }
}

function encodeQueryData(data)
{
   var ret = [];
   for (var d in data)
      ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
   return ret.join("&");
}

var DB = require('./DB.js');
global.self = global; //DO NOT DELETE

var NextContextID = -1;

function copyFile(source, destination, encoding, completion)
{
  RNFS.readFile(source.replace(/file\:\/\//g, ''), encoding).then((contents) =>
  {
    RNFS.writeFile(destination.replace(/file\:\/\//g, ''), contents, encoding)
    .then((success) => {
      if( completion ) completion(success);
    })
    .catch((err) => {
      //console.log(err.message);
      if( completion ) completion(true);
    });
  })
  .catch((err) =>
  {
    //console.log(err.message, err.code);
    if( completion ) completion(false);
  });
}

// for now, return that there is no '.' in the name
function isDir(fileName)
{
  return fileName.search('\\.') < 0;
}

function encodingForFile(fileName)
{
  if( fileName.search('\\.plist') >= 0 || fileName.search('\\.json') >= 0 ) return 'utf8';

  return 'base64';
}

function copyDirectory(source, destination, completion)
{
  RNFS.mkdir(destination.replace(/file\:\/\//g, '')).then((result) =>
  {
    //console.log("TESTREUP", "mkdir", result)
    var success = typeof result !== 'undefined' && result[0];
    RNFS.readDir(source.replace(/file\:\/\//g, ''))
    .then((result) =>
    {
      //console.log("TESTREUP", "readir", result)
      copyFiles(result, destination, function()
      {
        if( completion ) completion();
      })
    })
    .catch((err) =>
    {
      //console.log("TESTREUP", "readir error", err.message, err.code)
      completion()
    });
  }).catch((err) =>
  {
    //console.log("TESTREUP", "mkdir error", err)
  })
}

var __DEV__ = false;

function copyFiles(fileSources, fileDestination, completion, index)
{
  var currIndex = typeof index === 'undefined' ? 0 : index;
  if( currIndex >= fileSources.length )
  {
    if( completion ) completion();
    return;
  }

  var fileSource = fileSources[currIndex];
  var fileName = fileSource.name;
  var filePath = fileSource.path;
  var fileDestinationPath = fileDestination + '/' + fileName;
  if( isDir(fileName) )
  {
    copyDirectory(filePath.replace(/file\:\/\//g, ''), fileDestinationPath.replace(/file\:\/\//g, ''), function(didSucceed)
    {
      copyFiles(fileSources, fileDestination.replace(/file\:\/\//g, ''), completion, ++currIndex);
    })
  }
  else
  {
    var encoding = encodingForFile(fileName);
    copyFile(filePath.replace(/file\:\/\//g, ''), fileDestinationPath.replace(/file\:\/\//g, ''), encoding, function(didSucceed)
    {
      copyFiles(fileSources, fileDestination.replace(/file\:\/\//g, ''), completion, ++currIndex);
    })
  }
}

function deleteDirectory(directory, completion)
{
  RNFS.unlink(directory)
  .then(() =>
  {
    if( completion ) completion();
  })
  .catch((err) =>
  {
    if( completion ) completion();
  });
}

var tableData = [
  {tableName:"Variables", primaryKey:"key"},
  {tableName:"Auphan", primaryKey:"store_id"},
]

var AppManager =
{
  getReUpScrollViewContext : function()
  {
    NextContextID++;

    return "ReUpScrollView" + NextContextID;
  },

  _isDemo : findGetParameter("isDemo"),
  TUTORIAL_LAST_VIEWED : "TUTORIAL_LAST_VIEWED",
  _eventEmitter : new EventEmitter(),
  _dbManager : new DBManager(),
  _varTable : null,
  _fontScale : 1,
  _imageCachePostfix : 0,
  _hasInitialized : false,
  _availableLocales: [],
  _activeLocale: null,
  _deviceLocale: null,

  initialize : function(completion)
  {
    if( typeof screen !== 'undefined' && typeof screen.lockOrientation !== 'undefined' ) screen.lockOrientation("portrait-primary");
    this._hasInitialized = true;
    var thisThing = this;
    PushManager.initialize();
    DeepLinkManager.removeEventListener();
    DeepLinkManager.addEventListener(function(event){thisThing._handleOpenURL(event,thisThing);});
    if( DeviceEventEmitter )
    {
      DeviceEventEmitter.removeListener('didRegisterPush');
      DeviceEventEmitter.addListener(
        'didRegisterPush',
        (deviceInfo) =>
        {
          thisThing.setDeviceInfo(deviceInfo);
        }
      )
    }
    // AppState.removeEventListener('change'); // removing this for now, web is compaining if it removes a listener that doesn't exist
    AppState.addEventListener('change', (appState)=>{thisThing._handleAppStateChange(appState)});

    this._dbManager.initialize(tableData, function()
    {
      thisThing._varTable = thisThing._dbManager.table("Variables");
      thisThing._auphanTable = thisThing._dbManager.table("Auphan");
      thisThing.convertVariablesFromOldDB(function()
      {
        if( Platform.OS != 'web' )
        {
          PushNotification.configure({

              // (optional) Called when Token is generated (iOS and Android)
              onRegister: function(token) {
                thisThing.setDeviceInfo({
                  installationId:token.token,
                  deviceType:token.os
                });
              },

              // (required) Called when a remote or local notification is opened or received
              onNotification: function(notification) {
                  console.log( 'NOTIFICATION:', notification );
              },

              // ANDROID ONLY: GCM Sender ID (optional - not required for local notifications, but is need to receive remote push notifications)
              senderID: "873218453782",

              // IOS ONLY (optional): default: all - Permissions to register.
              permissions: {
                  alert: true,
                  badge: true,
                  sound: true
              },

              // Should the initial notification be popped automatically
              // default: true
              popInitialNotification: true,

              /**
                * (optional) default: true
                * - Specified if permissions (ios) and token (android and ios) will requested or not,
                * - if not, you must call PushNotificationsHandler.requestPermissions() later
                */
              requestPermissions: true,
          });
        }
        thisThing.syncDeviceInfo();
        thisThing.resetResourcesIfPackagedVersionIsNewer(function(version)
        {
          thisThing.checkForDownloadedResourcesAndSwap(function()
          {
            thisThing.initializeWithPList(PlatformConstants.configFileName, function()
            {
              if( RNReUpUpdater ) RNReUpUpdater.setResourceHeader(AppManager._appData.Header);
              thisThing.getCurrentUser();
              thisThing.updateCurrentPosition();
              AnalyticsManager.initialize(thisThing);
              thisThing._imageCachePostfix++;

              var doAfterDone = ()=>
              {
                thisThing.updateCurrentPosition();
                AnalyticsManager.initialize(thisThing);
                thisThing._imageCachePostfix++;
 
                if( Platform.OS == 'ios' )
                {
                  AccessibilityManager.getMultiplier((value) => {
                      thisThing._fontScale = value;
                      if( completion ) completion();
                  })
                }
                else
                {
                  if( completion ) completion();
                }
                thisThing._checkURL(thisThing);
              }

              var appManager = AppManager;
              var locManager = AppManager.getLocalizationManager();
              var features = thisThing.getFeatureDict();
              if( typeof features.FeedPlus !== 'undefined') features.FeedPlus.data.title = locManager.localizedStringForKey("FEED_TITLE");
              if( typeof features.PhoneNumberVerify !== 'undefined')
              {
                features.PhoneNumberVerify.data.title = locManager.localizedStringForKey("SET_PHONE_TITLE");
                features.PhoneNumberVerify.data.instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
              } 
              if( typeof features.Birthday !== 'undefined')
              {
                features.Birthday.data.title = locManager.localizedStringForKey("SET_BIRTHDAY_TITLE");
                features.Birthday.data.instructions = locManager.localizedStringForKey("SET_BIRTHDAY_INSTRUCTIONS");
              } 
              if( typeof features.PhoneNumberVerify !== 'undefined')
              {
                features.PhoneNumberVerify.data.title = locManager.localizedStringForKey("SET_PHONE_TITLE");
                features.PhoneNumberVerify.data.instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
              } 
              if( typeof features.SimpleSettings !== 'undefined') features.SimpleSettings.data.title = locManager.localizedStringForKey("SIMPLE_SETTINGS_TITLE");
              if( typeof features.SimpleCreateUser !== 'undefined') features.SimpleCreateUser.data.title = locManager.localizedStringForKey("SIMPLE_CREATE_USER_TITLE");
              if( typeof features.SimpleCFD !== 'undefined') features.SimpleCFD.data.title = locManager.localizedStringForKey("LOGIN_TITLE");
              if( typeof features.ProHome !== 'undefined') features.ProHome.data.title = locManager.localizedStringForKey("FEED_TITLE");

              var userID = findGetParameter("userid");
              var hash = findGetParameter("hash");
              if( (findGetParameter("isPass") == "1" || findGetParameter("isPassFree") == "1" || findGetParameter("isPassPro") == "1") )
              {
                if( userID != null && hash != null )
                {
                  // logged into correct account, proceed to pass home
                  NetworkManager.getUser(appManager, userID, hash, (urlUser)=>
                  {
                    if( typeof urlUser["ExtFirstName"] !== 'undefined' ) appManager._urlFirstName = urlUser["ExtFirstName"];
                    if( typeof urlUser["ExtLastName"] !== 'undefined' ) appManager._urlLastName = urlUser["ExtLastName"];
                    if( typeof urlUser["ExtEmail"] !== 'undefined' && urlUser["ExtEmail"].indexOf("@") > 0 ) appManager._urlEmail = urlUser["ExtEmail"];
                    
                    urlUser[ModelConstants.Password] = hash;
                    NetworkManager.getLinkedUsers(appManager, userID, hash, (linkedUsers)=>
                    {
                      var emailUser = null;
                      var phoneUser = null;
                      for( var i = 0; i < linkedUsers.length; i++ )
                      {
                        if( linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app" ) emailUser = linkedUsers[i];
                        if( linkedUsers[i]["Type"] == "phone" ) phoneUser = linkedUsers[i];
                      }

                      if( emailUser == null )
                      {
                        AppManager._currentUser = null;
                        thisThing._needsRegistration = true;
                        doAfterDone();
                      }
                      else
                      {
                        userID = emailUser[ModelConstants.UserID];
                        hash = emailUser[ModelConstants.Hash];
                        NetworkManager.getUser(appManager, userID, hash, (emailUserUpdated)=>
                        {
                          emailUserUpdated[ModelConstants.Password] = emailUserUpdated[ModelConstants.Hash];
                          appManager.setCurrentUser(emailUserUpdated, ()=>
                          {
                            doAfterDone();
                          })
                        }, ()=>
                        {
                          AppManager._currentUser = null;
                          AppManager._expiredLink = true;
                          doAfterDone();
                        }, ()=>
                        {
                          AppManager._currentUser = null;
                          AppManager._expiredLink = true;
                          doAfterDone();
                        })
                      }
                    }, (errorData)=>
                    {
                      AppManager._currentUser = null;
                      AppManager._expiredLink = true;
                      doAfterDone();
                      console.log("errorData",errorData)
                    }, (errorData)=>
                    {
                      AppManager._currentUser = null;
                      AppManager._expiredLink = true;
                      doAfterDone();
                      console.log("errorData",errorData)
                    })
                  }, ()=>
                  {
                    AppManager._currentUser = null;
                    AppManager._expiredLink = true;
                    doAfterDone();
                  }, ()=>
                  {
                    AppManager._currentUser = null;
                    AppManager._expiredLink = true;
                    doAfterDone();
                  })
                }
                else if( appManager._isDemo )
                {
                  NetworkManager.login(appManager, "kjregan10@gmail.com", "asdfwxyzabcd", (urlUser)=>
                  {
                    userID = urlUser[ModelConstants.UserID];
                    hash = urlUser[ModelConstants.Hash];
                    NetworkManager.getLinkedUsers(appManager, userID, hash, (linkedUsers)=>
                    {
                      var emailUser = null;
                      var phoneUser = null;
                      for( var i = 0; i < linkedUsers.length; i++ )
                      {
                        if( linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app" ) emailUser = linkedUsers[i];
                        if( linkedUsers[i]["Type"] == "phone" ) phoneUser = linkedUsers[i];
                      }

                      if( emailUser == null )
                      {
                        thisThing._needsRegistration = true;
                        doAfterDone();
                      }
                      else
                      {
                        userID = emailUser[ModelConstants.UserID];
                        hash = emailUser[ModelConstants.Hash];
                        NetworkManager.getUser(appManager, userID, hash, (emailUser)=>
                        {
                          emailUser[ModelConstants.Password] = hash;
                          appManager.setCurrentUser(emailUser, ()=>
                          {
                            doAfterDone();
                          })
                        }, ()=>
                        {
                          AppManager._currentUser = null;
                          AppManager._expiredLink = true;
                          doAfterDone();
                        }, ()=>
                        {
                          AppManager._currentUser = null;
                          AppManager._expiredLink = true;
                          doAfterDone();
                        })
                      }
                    }, (errorData)=>
                    {
                      AppManager._currentUser = null;
                      AppManager._expiredLink = true;
                      doAfterDone();
                      console.log("errorData",errorData)
                    }, (errorData)=>
                    {
                      AppManager._currentUser = null;
                      AppManager._expiredLink = true;
                      doAfterDone();
                      console.log("errorData",errorData)
                    })
                  }, ()=>
                  {
                    AppManager._currentUser = null;
                    AppManager._expiredLink = true;
                    doAfterDone();
                  }, ()=>
                  {
                    AppManager._currentUser = null;
                    AppManager._expiredLink = true;
                    doAfterDone();
                  })
                }
                else
                {
                  AppManager._currentUser = null;
                  AppManager._needsCFD = true;
                  doAfterDone();
                }
              }
              else
              {
                thisThing.getCurrentUser();

                doAfterDone();
              }
            });
          });
        });
      })
    })
  },

  getActiveLocale: function()
  {
    var devicelocalehaschanged = (window.navigator.userLanguage || window.navigator.language) != this._deviceLocale;
    if( this._activeLocale == null || devicelocalehaschanged )
    {
      var deviceLocale = this.getDeviceLocale();
      var localeSet = false;
      //checking for exact match
      for( var i = 0; i < this._availableLocales.length; i++ )
      {
        if( this._availableLocales[i] == deviceLocale ) 
        {
          this._activeLocale  = this._availableLocales[i];
          localeSet = true;
          break;
        }
      }

      if( !localeSet )
      {
       //checking for major language match
        for( var i = 0; i < this._availableLocales.length; i++ )
        {
          var majorLangDevice = deviceLocale.substr(0,2);
          var majorLangAvailableLocale = this._availableLocales[i].substr(0,2);
          if( majorLangDevice == majorLangAvailableLocale) 
          {
            this._activeLocale  = this._availableLocales[i];
            localeSet = true;
            break;
          }
        }
      }
      if( !localeSet ) this._activeLocale = "";
    }

    return this._activeLocale;
  },

  getDeviceLocale: function()
  {
    if( this._deviceLocale == null || this._deviceLocale != (window.navigator.userLanguage || window.navigator.language) )
    {
      RNFS.readFile(PlatformConstants.configFileName.replace(/file\:\/\//g, '')).then((contents) =>
      {
        var data = plist.parse(contents);//plist.parse();
        AppManager.setAppData(data);
      }).catch((error) =>
      {

      })
        this._deviceLocale = this.getDeviceInfo().locale;
    }

    return this._deviceLocale;
  },

  setAvailableLocales: function(data)
  {
    var appData = Object.keys(data);
    var localesfound = [];
    const LocalizedStringPlistElement = "LocalizedStrings";
    const HeaderPlistElement = "Header";
    const FeaturePlistElement = "Features";

    appData.forEach((element) => {
      var thisLocale = "";
      if( element.includes(LocalizedStringPlistElement) )
      {
        var LocalizedStringLength = LocalizedStringPlistElement.length;
        var elementStringLength = element.length;
        // default lang
        if(elementStringLength == LocalizedStringLength) return;

        var thisLocale = element.substr(LocalizedStringLength + 1, elementStringLength);
        var localeDefined = false;
        localesfound.forEach((foundLocales) => 
        {
          if(typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale)
          {
            foundLocales.frequency = foundLocales.frequency + 1;
            localeDefined = true;
            return;
          }
        });
        if( !localeDefined )
        {
          localesfound.push({"locale": thisLocale, "frequency": 1})
        }
      }
      if( element.includes(HeaderPlistElement) )
      {
        var HeaderLength = HeaderPlistElement.length;
        var elementStringLength = element.length;
        // default lang
        if(elementStringLength == HeaderLength) return;

        var thisLocale = element.substr(HeaderLength + 1, elementStringLength);
        var localeDefined = false;
        localesfound.forEach((foundLocales) =>
        {
          if(typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale)
          {
            foundLocales.frequency = foundLocales.frequency + 1;
            localeDefined = true;
            return;
          }
        });
        if( !localeDefined )
        {
          localesfound.push({"locale": thisLocale, "frequency": 1})
        }
      }
      if( element.includes(FeaturePlistElement) )
       {
        var FeatureLength = FeaturePlistElement.length;
        var elementStringLength = element.length;
        // default lang
        if(elementStringLength == FeatureLength) return;

        var thisLocale = element.substr(FeatureLength + 1 , elementStringLength);
        var localeDefined = false;
        localesfound.forEach((foundLocales) =>
        {
          if(typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale)
          {
            foundLocales.frequency = foundLocales.frequency + 1;
            localeDefined = true;
            return;
          }
        });
        if( !localeDefined )
        {
          localesfound.push({"locale": thisLocale, "frequency": 1})
        }
      }
    });
    
    var self = this;
    localesfound.forEach((foundLocales) =>
    {
      if( foundLocales.frequency == 3 ) self._availableLocales.push(foundLocales.locale);
    });
  },

  initializeWithPList: function(plistPath, completion)
  {
    var contentsHandler = (contents) =>
    {
      // log the file contents
      // var plist = new PlistParser.PlistParser(contents);
      var data = contents;
      if( typeof contents === 'string' )
      {
        var plist = new PlistParser.PlistParser(contents);
        data = plist.parse();
      }

      AppManager.setAvailableLocales(data);
      AppManager.setAppData(data);
      // check if we are logged in
      AppManager.getCurrentUser(function(user)
      {
        if( completion ) completion(data);
      });
    };

    if( typeof this.configOverride !== 'undefined' && this.configOverride != null )
    {
      contentsHandler(this.configOverride);
    }
    else
    {
      RNFS.readFile(plistPath.replace(/file\:\/\//g, '')).then(contentsHandler)
      .catch((err) =>
      {
        //console.log(err.message, err.code);
      });
    }
  },

  resetResources: function(completion)
  {
    if( Platform.OS == "web" )
    {
      completion();
      return;
    }
    var sourceDir = PlatformConstants.packagedResourcesDirectory;
    var destDir = PlatformConstants.resourcesDirectory;
    copyDirectory(sourceDir, destDir, completion);
  },

  resetResourcesIfPackagedVersionIsNewer: function(completion)
  {
    var thisThing = this;
    this.getVariable('lastInstalledVersion', function(bundleVersion)
    {
      if( bundleVersion != null && BundleVersion != bundleVersion )
      {
        thisThing.resetResources(()=>{completion(true)});
      }
      else
      {
        completion(false);
      }
    });
  },

  doResourcesExist: function(completion)
  {
    RNFS.readFile(PlatformConstants.configFileName.replace(/file\:\/\//g, ''), 'utf8').then((contents) =>
    {
      if( completion ) completion(contents.length > 0);
    })
    .catch((err) =>
    {
      if( completion ) completion(false);
    });
  },

  doPendingResourcesExist: function(completion)
  {
    RNFS.readFile(PlatformConstants.pendingConfigFileName.replace(/file\:\/\//g, ''), 'utf8').then((contents) =>
    {
      if( completion ) completion(contents.length > 0);
    })
    .catch((err) =>
    {
      if( completion ) completion(false);
    });
  },

  doesResourceExist: function(filePath, completion)
  {
    RNFS.exists(PlatformConstants.resourcesDirectory.replace(/file\:\/\//g, '') + "/" + filePath).then(completion);
  },

  syncPendingResources: function(completion)
  {
    if( Platform.OS == "web" )
    {
      completion();
      return;
    }
    var thisThing = this;
    this.getVariable('lastInstalledVersion', function(value)
    {
      thisThing.setVariable('lastInstalledVersion', BundleVersion, function(){});
      var shouldReset = typeof value === 'undefined' || value == null;
      var thisBundleVersionParts = BundleVersion.split(".");
      if( !shouldReset && thisBundleVersionParts.length == 3 )
      {
        var valueParts = value.split('.');
        if( valueParts.length == 3 )
        {
          shouldReset |= (parseInt(valueParts[2]) < parseInt(thisBundleVersionParts[2]));
        }
      }
      if( shouldReset )
      {
        thisThing.resetResources(function()
        {
          if( completion ) completion(true);
        })
      }
      else
      {
        var sourceZip = PlatformConstants.pendingResourcesDirectory.replace(/file\:\/\//g, '') + ".zip";//PlatformConstants.pendingResourcesDirectory + '.zip';
        if( RNZipManager )
        {
          RNZipManager.unzip(sourceZip, PlatformConstants.absoluteFilesPrefix.replace(/file\:\/\//g, ''), true, function(didSucceed)
          {
            if( completion ) completion(true);
          });
        }
        else
        {
          if( completion ) completion(true);
        }
      }
    })
  },

  checkForDownloadedResourcesAndSwap: function(completion)
  {
    var appManager = this;
    appManager.syncPendingResources(function()
    {
      appManager.doResourcesExist(function(resourceExist)
      {
        if( resourceExist )
        {
          if( completion ) completion();
        }
        else
        {
          appManager.resetResources(function()
          {
            if( completion ) completion();
          })
        }
      })
    })
  },

  _didDownloadResources : false,
  downloadNewResources : function()
  {
    if( this._didDownloadResources ) return;
    this._didDownloadResources = true;

    var mockSize = 1400000;
    var appManager = this;
    var resourceUpdaterURL = "https://builder.getreup.com/php/ResourceManager.php?";
    if( typeof this._appData["ResourceVersions"] === 'undefined' || typeof this._appData["ResourceVersions"]["ReUp-Config.plist"] === 'undefined' ) return;

    var params = {
      methodName:"DownloadResources",
      appID:this._appData["Header"]["AppID"],
      bundleVersion:BundleVersion,
      resourceVersion:this._appData["ResourceVersions"]["ReUp-Config.plist"],
      platform:Platform.OS,
      config:__DEV__ ? 'dev' : 'prod'
    }
    resourceUpdaterURL = resourceUpdaterURL + encodeQueryData(params)
    var options = {
      fromUrl: resourceUpdaterURL,          // URL to download file from
      toFile: PlatformConstants.pendingResourcesDirectory.replace(/file\:\/\//g, '') + ".zip",           // Local filesystem path to save the file to
      background: true,
      begin: function(downloadBeginCallbackResult)
      {
        var {jobID, statusCode, contentLength, headers} = downloadBeginCallbackResult;
        appManager._eventEmitter.emit("downloadStarted");
      },
      progress: function(downloadProgressCallbackResult)
      {
        var {jobID, contentLength, bytesWritten} = downloadProgressCallbackResult;
        //console.log(progressObj.bytesWritten)
        appManager._eventEmitter.emit("downloadProgressed", {progress: 100*bytesWritten/mockSize});
      }
    }

    if( RNFS.downloadFile )
    {
      RNFS.downloadFile(options).promise.then((downloadResult) =>
      {
        if( appManager._didDownloadResources ) appManager._eventEmitter.emit("downloadCompleted", {updateSuccess:typeof downloadResult.bytesWritten !== 'undefined' && downloadResult.bytesWritten > 0});
        appManager._didDownloadResources = false;
      }).catch((err)=>
      {
        appManager._didDownloadResources = false;
      });
    }
  },

  _checkURL : function(thisThing)
  {
    DeepLinkManager.getLaunchedURL(function(url)
    {
      if( url ) thisThing._handleOpenURL({url:url}, thisThing);
    })
  },

  _handleOpenURL : function(event, appManager)
  {
    if( appManager.isLoggedIn() ) return;

    var reupParam = getParameterByName(event.url, "REUPKEY");
    if( reupParam && reupParam.length > 0 )
    {
      var stateKey = getParameterByName(event.url, "REUPKEY");
      var base64Info = getParameterByName(event.url, "REUPINFO");

      if( base64Info )
      {
        var infoStr = atob(base64Info);
        if( infoStr )
        {
          var info = JSON.parse(infoStr);
          if( stateKey == "SMNRegistrationLogin" && typeof info[ModelConstants.UserName] !== 'undefined' )
          {
            var username = info[ModelConstants.UserName].toLowerCase();
            appManager.getTempUserPass(function(tempUserPass)
            {
              if( tempUserPass != null && tempUserPass.length > 1 && typeof tempUserPass[0] !== 'undefined' && (tempUserPass[0].toLowerCase() == username.toLowerCase()) )
              {
                if( appManager.loginCallBackStart ) appManager.loginCallBackStart();
                NetworkManager.login(appManager, tempUserPass[0].trim(), tempUserPass[1], function(data)
                {
                  AnalyticsManager.logLoginEvent(appManager, 'auto', true);
                  data[ModelConstants.Password] = tempUserPass[1];
                  appManager.setCurrentUser(data, function()
                  {
                    if( appManager.loginCallBackFinish ) appManager.loginCallBackFinish();
                  })

                }, function(data)
                {
                  AnalyticsManager.logLoginEvent(appManager, 'auto', false);
                  if( appManager.loginCallBackFinish ) appManager.loginCallBackFinish();
                }, function(data)
                {
                  AnalyticsManager.logLoginEvent(appManager, 'auto', false);
                  if( appManager.loginCallBackFinish ) appManager.loginCallBackFinish();
                })
              }
            })
          }
        }
      }
    }
  },

  _shouldShowLocKeys: findGetParameter('domain') != null,
  _handleAppStateChange : function(appState)
  {
    if( appState == 'active' )
    {
      this.downloadNewResources();
    }
  },

  _appData : {},
  setAppData: function(data)
  {
    var locManager = this.getLocalizationManager();
    var header = data["Header"];
		var appName = header["AppName"];
		var appNameLong = header["AppNameLong"];
		var fonts = data["Fonts"];
    var defaultCurrency = header["DefaultCurrency"];
    var defaultCurrencySymbol = header["DefaultCurrencySymbol"];
    if( typeof fonts !== 'undefined' ) this.setFonts(fonts)
    if( typeof defaultCurrency !== 'undefined' ) this.setCurrency(defaultCurrency);
    if( typeof defaultCurrencySymbol !== 'undefined' ) this.setCurrencySymbol(defaultCurrencySymbol);
    this.appName = appName;
    this.appNameLong = appNameLong;
    var locale = this.getActiveLocale();
    var featureDatas = (typeof locale !== 'undefined' && typeof data["Features-" + locale] !== 'undefined') ? data["Features-" + locale] : data['Features'];
    if( typeof data["Features-" + locale.split('-')[0]] !== 'undefined' ) featureDatas = data["Features-" + locale.split('-')[0]];
    if( typeof data["Features-" + locale] !== 'undefined' ) featureDatas = data["Features-" + locale];
    this._appData = data;
    this.setFeatureDatas(featureDatas);
    if( typeof featureDatas.FeedPlus === 'undefined' )
    {
        featureDatas.FeedPlus = {
        bgImage:'background.png',
        headerImage:'header.png',
        title:'Feed',
        shouldShowInMenu:false
      }
    }
    if( typeof featureDatas.PhoneNumberVerify === 'undefined' )
    {
      var verifyPhoneNumberTitleString = locManager.localizedStringForKey("SET_PHONE_TITLE");
      var verifyPhoneNumberInstructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
      featureDatas.PhoneNumberVerify = 
      {
        title:verifyPhoneNumberTitleString,
        shouldShowInMenu:false,
        instructions:verifyPhoneNumberInstructions
      }
    }
    if( typeof featureDatas.Birthday === 'undefined' )
    {
      var setBirthdayTitleString = locManager.localizedStringForKey("SET_BIRTHDAY_TITLE");
      var setBirthdayInstructions = locManager.localizedStringForKey("SET_BIRTHDAY_INSTRUCTIONS");
      featureDatas.Birthday = 
      {
        title:setBirthdayTitleString,
        icon:"birthday-cake",
        shouldShowInMenu:false,
        instructions:setBirthdayInstructions
      }
    }

		var features = [];
    var featureDict = {};
    var shouldShowFeatureKey = this._shouldShowLocKeys;
		for( var featureName in featureDatas )
		{
			var featureData = featureDatas[featureName];
			featureData["name"] = featureName;
      var feature =  {data:featureData, key:featureName};
      if( shouldShowFeatureKey )
      {
        feature.data.title = "Feature." +  featureName + ".title";
        feature.data.instructions = "Feature." +  featureName + ".instructions";
        feature.data.instructions2 = "Feature." +  featureName + ".instructions2";
        feature.data.tip = "Feature." +  featureName + ".tip";
        feature.data.shortTitle = "Feature." +  featureName + ".shortTitle";
      }
			features.push(feature);
			featureDict[featureName] = feature;
		}

    var adminFeatureDatas = data["Features-admin"];
		var adminFeatures = [];
		var adminFeatureDict = {};
		for( var featureName in adminFeatureDatas )
		{
			var featureData = adminFeatureDatas[featureName];
      featureData["name"] = featureName;
      console.log("in feature name admin" + featureName);
      var feature =  {data:featureData, key:featureName};
      if( shouldShowFeatureKey )
      {
        feature.data.title = "Features-admin." +  featureName + ".title";
        feature.data.instructions = "Features-admin." +  featureName + ".instructions";
        feature.data.instructions2 = "Features-admin." +  featureName + ".instructions2";
        feature.data.tip = "Features-admin." +  featureName + ".tip";
        feature.data.shortTitlep = "Features-admin." +  featureName + ".shortTitle";
      }
			adminFeatures.push(feature);
			adminFeatureDict[featureName] = feature;
		}

    this.setFeatures(features, adminFeatures);
    this.setFeatureDict(featureDict, adminFeatureDict);


    this._appData = data;
    if(findGetParameter("isPass") == "1")
    {
      // this._appData.MainScreen.rootFeature = "PassHome";
      // this._appData.MainScreen.disableNavHeader = true;
      this._appData.MainScreen.disableFeed = true;
      this._appData.MainScreen.buttonType = 2;
      // if( typeof this._appData.Features.FeedPlus !== 'undefined' ) this._appData.Features.FeedPlus.feedPlusType = 2;
    }
    else if(findGetParameter("isPassFree") == "1")
    {
      this._appData.MainScreen.rootFeature = "BasicHome";
      this._appData.MainScreen.disableNavHeader = true;
      this._appData.MainScreen.disableFeed = true;
      this._appData.MainScreen.buttonType = 2;
      if( typeof this._appData.Features.FeedPlus !== 'undefined' ) this._appData.Features.FeedPlus.feedPlusType = 2;
    }
    else if(findGetParameter("isPassPro") == "1")
    {
      this._appData.MainScreen.rootFeature = "ProHome";
      this._appData.MainScreen.disableNavHeader = true;
      this._appData.MainScreen.disableFeed = true;
      this._appData.MainScreen.buttonType = 2;
      if( typeof this._appData.Features.FeedPlus !== 'undefined' ) this._appData.Features.FeedPlus.feedPlusType = 2;
    }
    // sets the status bar
    var headerColor = this.getColorDictionary()["HeaderColor"];
    var hex = headerColor[0];
    var isBright = false;
    if( typeof hex === 'undefined' ) hex = headerColor["0"];
    if( typeof hex !== 'undefined' )
    {
      isBright = calcLuminance(hex) > 0.6;
      StatusBar.setBarStyle(!isBright ? 'light-content' : 'default',true)
    }

    if( typeof hex !== 'undefined' && Platform.OS != 'ios' )
    {
      var headerColor = this.getColorDictionary()["HeaderColor"];
      var headerColorHex = headerColor[0];
      var androidStatusColor = isBright ? hex : headerColorHex;
      var darkenedColor = shadeBlend(-0.6, "#"+androidStatusColor);
      StatusBar.setBackgroundColor(darkenedColor, true);
    }
  },

  getResourceInfo: function()
  {
    var resourceInfo = "";
    for( var key in this._appData.Header )
    {
      if( resourceInfo.length > 0 ) resourceInfo += "\n";
      var info = this._appData.Header[key];
      resourceInfo += key + ": " + info;
    }
    return resourceInfo;
  },

  getAppData: function()
  {
    return this._appData;
  },

  getImageKey: function(name)
  {
    return name + "-" + this._imageCachePostfix;
  },

  absoluteResourceForPath: function( pathRelativeToReUpResources )
  {
    return PlatformConstants.resourcesDirectory + "/" + pathRelativeToReUpResources + (typeof this._imageCacheIndex !== 'undefined' ? ("?"+this._imageCacheIndex) : "");
  },

  _fonts:{},
  setFonts:function(fonts)
  {
    this._fonts = fonts;
  },

  getFontForKey:function(key)
  {
    if( typeof this._fonts[key] === 'undefined' )
    {
      if( typeof this._fonts.Regular === 'undefined' ) return "Helvetica";

      return this._fonts.Regular;
    }

    return this._fonts[key];
  },

  setAvailableFonts:function(fonts)
  {
    if( this._fonts == null || typeof this._fonts === 'undefined' ) return;
    if( typeof fonts === 'undefined' ) fonts = [];

    var refinedFonts = {};
    for( var key in this._fonts )
    {
      var foundFont = false;
      var fontName = this._fonts[key];
      for( var i = 0; i < fonts.length; i++ )
      {
        if( fonts[i] == fontName )
        {
          foundFont = true;
          break;
        }
      }
      if( foundFont ) refinedFonts.key = fontName;
      if( !foundFont ) alert(fontName)
    }

    this._fonts = refinedFonts;
  },

  _defaultCurrency: "CAD",
  _defaultCurrencySymbol: "$",
  setCurrency: function(currency)
  {
    this._defaultCurrency = currency;
  },
  setCurrencySymbol: function(currencySymbol)
  {
    this._defaultCurrencySymbol = currencySymbol;
  },

  getCurrencySign: function()
  {
    return this._defaultCurrencySymbol;

  },

  _features : [],
  _adminFeatures : [],
  _topRightFeatures : [],
  setFeatures : function(features, adminFeatures)
  {
    this._features = features;
    this._adminFeatures = adminFeatures;
    var topRightFeatures = [];
    for( var i = 0; i < features.length; i++ )
    {
      var feature = features[i];
      if( typeof feature !== 'undefined' && typeof feature.data !== 'undefined' && feature.data.shouldShowTopRight )
      {
        topRightFeatures.push(feature);
      }
    }

    this._topRightFeatures = topRightFeatures;

    // TODO: remove this
    // this._topRightFeatures = [{
    //   key:"EarnPay",
    //   data:{
    //     title:"Pay • Earn",
    //     shortTitle:"Pay",
    //     icon:"credit-pay",
    //     requiresLogin:true,
    //     name:"EarnPay",
    //   }
    // }]
  },

  getTopRightFeatures: function()
  {
    return this._topRightFeatures;
  },

  getFeatures: function()
  {
    if( this.isAdminLoggedIn() ) return this._adminFeatures;

    return this._features;
  },

  getMobileOperatingSystem: function() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "windows";
      }

      if (/android/i.test(userAgent)) {
          return "android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "ios";
      }

      return "unknown";
  },

  _featureVersion:0,
  setFeatureDatas: function(featureDatas)
  {
    this._featureVersion++;
    var locManager = this.getLocalizationManager();
    var myCardTitleString = locManager.localizedStringForKey("MY_CARD_TITLE");
    var simpleSettingsTitleString = locManager.localizedStringForKey("SIMPLE_SETTINGS_TITLE");
    var createAccountTitleString = locManager.localizedStringForKey("CREATE_USER_TITLE");
    var cfdTitleString = locManager.localizedStringForKey("CFD_TITLE");
    var loginTitleString = locManager.localizedStringForKey("LOGIN_TITLE");
    var verifyPhoneNumberTitleString = locManager.localizedStringForKey("SET_PHONE_TITLE");
    var feedTitleString = locManager.localizedStringForKey("FEED_TITLE");
    var verifyPhoneNumberInstructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");

    if( typeof featureDatas.FeedPlus === 'undefined' )
    {
        featureDatas.FeedPlus = {
        bgImage:'background.png',
        headerImage:'header.png',
        title:'Feed',
        shouldShowInMenu:false
      }
    }

    if(findGetParameter("isPass") == "1")
    {
      // featureDatas.PassHome = {
      //   bgImage:'background.png',
      //   headerImage:'header.png',
      //   title:'Feed',
      //   shouldShowInMenu:false
      // }
      if( typeof featureDatas.MyCard === 'undefined' )
      {
        featureDatas.MyCard = {
          title:myCardTitleString,
          shouldShowOnFeedPlus:true,
          shouldShowInMenu:false,
          icon:'fa-qrcode',
          shouldShowTopRight:true,
        }        
      }
      featureDatas.SimpleSettings = {
        title:simpleSettingsTitleString,
        shouldShowOnFeedPlus:true,
        shouldShowInMenu:false,
      }
      featureDatas.SimpleCreateUser = {
        title:createAccountTitleString,
        shouldShowOnFeedPlus:false,
        shouldShowInMenu:false,
      }
      featureDatas.SimpleCFD = {
        title:cfdTitleString,
        shouldShowOnFeedPlus:false,
        shouldShowInMenu:false,
      }
      featureDatas.SimpleLogin = {
        title:loginTitleString,
        shouldShowOnFeedPlus:false,
        shouldShowInMenu:false,
      }
      if( typeof featureDatas.Rewards !== 'undefined' )
      {
        featureDatas.Rewards.title = featureDatas.Rewards.shortTitle;
      }
      if( typeof featureDatas.PhoneNumberVerify !== 'undefined' )
      {
        featureDatas.PhoneNumberVerify.title = verifyPhoneNumberTitleString;
      }
      // earnPayFeatureData.data.shouldShowOnFeedPlus = false;
      // useCreditFeatureData.data.shouldShowOnFeedPlus = false;
      // rewardsFeatureData.data.shouldShowOnFeedPlus = true;
      // if( typeof auphanFeatureData !== 'undefined' ) auphanFeatureData.data.shouldShowOnFeedPlus = true;
      // if( typeof grabbFeatureData !== 'undefined' ) grabbFeatureData.data.shouldShowOnFeedPlus = true;

      delete featureDatas.Instagram;
      delete featureDatas.EarnPay;
      delete featureDatas.Auphan;
      delete featureDatas.Grabb;
      delete featureDatas.Tutorial;
      delete featureDatas.Settings;
      delete featureDatas.Twitter;
      delete featureDatas.Facebook;
      this._showTopBar = false;
      if( typeof featureDatas.Rewards !== 'undefined' ) featureDatas.Rewards.shouldShowOnFeedPlus = true;
    }
    else if(findGetParameter("isPassFree") == "1")
    {
      featureDatas.BasicHome = {
        bgImage:'background.png',
        headerImage:'header.png',
        title:feedTitleString,
        shouldShowInMenu:false
      }
      featureDatas.SimpleCFD = {
        title:cfdTitleString,
        shouldShowOnFeedPlus:false
      }
      featureDatas.TermsPreferences = {
        title:'',
        shouldShowOnFeedPlus:false
      }
      featureDatas.SimpleSettings = {
        title:simpleSettingsTitleString,
        shouldShowOnFeedPlus:true
      }
      delete featureDatas.RewardsCampaigns;
      delete featureDatas.Instagram;
      delete featureDatas.EarnPay;
      delete featureDatas.RewardsCampaigns;
      delete featureDatas.Auphan;
      delete featureDatas.Grabb;
      delete featureDatas.Tutorial;
      delete featureDatas.Twitter;
      delete featureDatas.PhoneNumberVerify;
    }
    else if(findGetParameter("isPassPro") == "1")
    {
      featureDatas.ProHome = {
        bgImage:'background.png',
        headerImage:'header.png',
        title:feedTitleString,
        shouldShowInMenu:false
      }
      featureDatas.SimpleCFD = {
        title:cfdTitleString,
        shouldShowOnFeedPlus:false
      }
      featureDatas.TermsPreferences = {
        title:'',
        shouldShowOnFeedPlus:false
      }
      featureDatas.SimpleSettings = {
        title:simpleSettingsTitleString,
        shouldShowOnFeedPlus:true
      }
      delete featureDatas.RewardsCampaigns;
      delete featureDatas.Instagram;
      delete featureDatas.EarnPay;
      delete featureDatas.RewardsCampaigns;
      delete featureDatas.Auphan;
      delete featureDatas.Grabb;
      delete featureDatas.Tutorial;
      delete featureDatas.Twitter;
      delete featureDatas.PhoneNumberVerify;
    }

    if( typeof featureDatas.PhoneNumberVerify === 'undefined' )
    {featureDatas.PhoneNumberVerify = {
      title:verifyPhoneNumberTitleString,
      shouldShowInMenu:false,
      instructions:verifyPhoneNumberInstructions
    }}
		var features = [];
		var featureDict = {};
		for( var featureName in featureDatas )
		{
			var featureData = featureDatas[featureName];
			featureData["name"] = featureName;
			var feature =  {data:featureData, key:featureName};
			features.push(feature);
			featureDict[featureName] = feature;
		}

    this.setFeatures(features, features);
    this.setFeatureDict(featureDict, featureDict);
  },

  _featureDict : {},
  _adminFeatureDict : {},
  setFeatureDict : function(featureDict, adminFeatureDict)
  {
    this._featureDict = featureDict;
    this._adminFeatureDict = adminFeatureDict;
  },

  getFeatureDict: function()
  {
    if( this.isAdminLoggedIn() ) return this._adminFeatureDict;

    return this._featureDict;
  },

  getRootFeature: function()
	{
		var featureName = this._appData.MainScreen.rootFeature;

		return this.getFeatureDict()[featureName]
	},

  shouldDisableNavHeader: function(index)
  {
    var shouldDisabled = (typeof this._appData.MainScreen.disableNavHeader !== 'undefined') && (this._appData.MainScreen.disableNavHeader == true);
    return shouldDisabled || (index == 0 && this.shouldDisableNavHeaderOnFirstScreen());
  },

  shouldUseFloatingNav: function()
  {
    return this._appData.MainScreen.rootFeature == "FeedPlus"
      || this._appData.MainScreen.rootFeature == "PassHome"
      || this._appData.MainScreen.rootFeature == "BasicHome"
      || this._appData.MainScreen.rootFeature == "ProHome"
      || this._appData.MainScreen.rootFeature == this.shouldUseTab();
  },

  shouldDisableNavHeaderOnFirstScreen: function()
  {
    return (this._appData.MainScreen.rootFeature == "FeedPlus") || ((typeof this._appData.MainScreen.disableNavHeaderOnFirstScreen !== 'undefined') && (this._appData.MainScreen.disableNavHeaderOnFirstScreen == true));
  },

  shouldUseTab: function()
  {
    return (typeof this._appData.MainScreen.shouldUseTab !== 'undefined') && (this._appData.MainScreen.shouldUseTab == true);
  },

  feedPlusType: function()
  {
    // return 1;
    // console.log("this._appData.Features.FeedPlus",this._appData.Features.FeedPlus);
    return (typeof this._appData.Features.FeedPlus === 'undefined' || typeof this._appData.Features.FeedPlus.feedPlusType === 'undefined') ? 0 : this._appData.Features.FeedPlus.feedPlusType;
  },

  shouldShowPassButton: function()
  {
    return Platform.OS == "web" && findGetParameter("isPass") == "1";
  },

  feedPlusTopOffsetPercentage: function()
  {
    // return 0.13;
    return typeof this._appData.Features.FeedPlus.topOffsetPercentage === 'undefined' ? 0 : this._appData.Features.FeedPlus.topOffsetPercentage;
  },

  feedPlusBottomOffsetPercentage: function()
  {
    // return 0.30;
    return typeof this._appData.Features.FeedPlus.bottomOffsetPercentage === 'undefined' ? 0 : this._appData.Features.FeedPlus.bottomOffsetPercentage;
  },

  shouldDisableLockOnFeedPlus: function()
  {
    return typeof this._appData.MainScreen.disableLockIcon === 'undefined' ? false : this._appData.MainScreen.disableLockIcon;
  },

  buttonType: function()
  {
    // return 1;
    return typeof this._appData.MainScreen.buttonType === 'undefined' ? 0 : this._appData.MainScreen.buttonType;
  },

  useCapsButtons: function()
  {
    // return true;
    return typeof this._appData.MainScreen.capsButtons === 'undefined' ? false : this._appData.MainScreen.capsButtons;
  },

  disableFeed: function()
  {
    return typeof this._appData.MainScreen.disableFeed === 'undefined' ? false : this._appData.MainScreen.disableFeed;
  },

  _showTopBar: true,
  showTopBar: function()
  {
    return this._showTopBar;
  },

  _expiredLink: false,
  expiredLink: function()
  {
    return this._expiredLink;
  },

  _needsRegistration: false,
  needsRegistration: function()
  {
    return this._needsRegistration;
  },

  _needsCFD: false,
  needsCFD: function()
  {
    return this._needsCFD;
  },

  shouldInvertColorOnFeedPlus: function()
  {
    return typeof this._appData.MainScreen.invertColor === 'undefined' ? false : (this._appData.MainScreen.invertColor && (this.feedPlusType() != 2));
  },

  disableInterstitial: function()
  {
    if( Platform.OS === 'web' ) return false;

    return typeof this._appData.MainScreen.disableInterstitial === 'undefined' ? false : this._appData.MainScreen.disableInterstitial;
  },

  findGetParameter: function(getParam)
  {
    return findGetParameter(getParam);
  },

  HAS_CONVERTED_KEY : "HAS_CONVERTED_KEY",
  convertVariablesFromOldDB: function(completion)
  {
    var thisThing = this;
    var varTable = this._dbManager.table("Variables");
    varTable.get(this.HAS_CONVERTED_KEY, function(obj)
    {
      if( obj == null || !obj.value )
      {
        DB.table("Variables").get_all(function(result)
        {
          var varDatas = Object.values(result.rows);
          varTable.setRows(varDatas, function()
          {
            varTable.set({key:thisThing.HAS_CONVERTED_KEY, value:true}, completion);
          });
        })
      }
      else
      {
        completion();
      }
    })
  },

  _externalLinkDates : {},
  externalLinkDateForFeatureName: function(featureName)
  {

    if( typeof this._externalLinkDates[featureName] !== 'undefined' )
    {
      return this._externalLinkDates[featureName];
    }

    var thisThing = this;
    var varKey = "externalLinkDate-" + featureName;
    this.getVariable(varKey, function(value)
    {
      if( value && value != null )
      {
        thisThing._externalLinkDates[featureName] = value;
      }
      else
      {
        thisThing._externalLinkDates[featureName] = (new Date()).getTime();
        thisThing.setVariable(varKey, (new Date()).getTime(), function()
        {

        })
      }
    });

    return 0; // assume it is forever ago;
  },

	getColorDictionary: function()
	{
		return this._appData["ColorDictionary"];
	},

  getTabFeatures: function()
	{
		var tabFeatures = [];
    var features = this.getFeatures();
		var numFeatures = features.length;
		for( var i = 0; i < numFeatures; i++ )
		{
			var feature = features[i];
			if( feature.data.shouldShowInTabs == true )
			{
				tabFeatures.push(feature);
			}
		}

		tabFeatures = tabFeatures.sort(function(a, b)
		{
			return a.data.tabSortOrder - b.data.tabSortOrder;
		})

		return tabFeatures;
	},

  getErrorColor: function() {
    var ContrastChecker = new ColorContrastChecker();
    var acceptableContrastRatio = 2.1;
    var defaultErrorColor = "#de2e37";
    var colorDictionary = this.getColorDictionary();

    var headerColor = colorDictionary["ProfileColor"][0];
    var profileTitleColor = colorDictionary["ProfileTitleColor"][0];
    var generalTitleColor = colorDictionary["GeneralTitleColor"][0];
    //console.log("Contrast",ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(headerColor),ContrastChecker.hexToLuminance('#de2e37')));
    if(ContrastChecker.isLevelCustom(headerColor,defaultErrorColor,acceptableContrastRatio)){
      //console.log("Contrast", "GOOD");

      return defaultErrorColor;
    }else {

      var generalTitleColorContrastRatio = ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(generalTitleColor),ContrastChecker.hexToLuminance('#de2e37'));
      var profileTitleColorContrastRatio = ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(profileTitleColor),ContrastChecker.hexToLuminance('#de2e37'));

      if (generalTitleColorContrastRatio>profileTitleColorContrastRatio){
        return "#"+generalTitleColor.toString()
      }else{
         return "#"+profileTitleColor.toString()
      }

    }
  },

  shouldContrastColor: function()
  {
    var ContrastChecker = new ColorContrastChecker();
    var acceptableContrastRatio = 2.1;
    var colorDictionary = this.getColorDictionary();
    var profileTitleColor = colorDictionary["ProfileTitleColor"][0];
    var white = "#fff";
        
    return !ContrastChecker.isLevelCustom(white, profileTitleColor, acceptableContrastRatio);
  },

  getMenuFeatures: function()
  {
		var menuFeatures = [];
    var features = this.getFeatures();
		var numFeatures = features.length;
    var mediaFeatures = []
		for( var i = 0; i < numFeatures; i++ )
		{
			var feature = features[i];
			if( feature.data.shouldShowInMenu != false )
			{
        if( (feature.data.name == "Instagram" || feature.data.name == "Facebook" || feature.data.name == "Twitter") && (typeof feature.data.forceMenu === 'undefined' || !feature.data.forceMenu) )
        {
          mediaFeatures.push(feature);
        }
        else
        {
          menuFeatures.push(feature);
        }
			}
		}

    if( mediaFeatures.length > 0 )
    {
      // for( var i = 0; i < mediaFeatures.length; i++ )
      // {
      //   var feature = mediaFeatures[i];
      //   var name = feature.data.name;
      //   if( name == "Promotions" )
      //   {
      //
      //   }
      // }
    }

		menuFeatures = menuFeatures.sort(function(a, b)
		{
			return a.data.menuSortOrder - b.data.menuSortOrder;
		})

    // TODO: remove
    // var featureNames = ["EarnPay", /*"Grabb",*/ "RewardsCampaigns", "Promotions", "Locations", "Gifts", /*"Passes", "Booking",*/ "Settings"];
    // var menuFeatures = [];
    // for( var i = 0; i < featureNames.length; i++ )
    // {
    //   menuFeatures.push(this.getFeatureForName(featureNames[i]));
    // }

		return menuFeatures;
  },

	getFeedFeatures: function()
	{
		var feedFeatures = [];
    var features = this.getFeatures();
		if( typeof features === 'undefined' ) return [];

		var numFeatures = features.length;
		var isLoggedIn = this.isLoggedIn();
		for( var i = 0; i < numFeatures; i++ )
		{
			var feature = features[i];
			if( feature.data.shouldShowInFeed && (isLoggedIn || !feature.data.requiresLogin))
			{
				feedFeatures.push(feature);
			}
		}

		return feedFeatures;
	},

  getFeedPlusFeatures: function()
	{
		var feedPlusFeatures = [];
    var features = this.getFeatures();
		if( typeof features === 'undefined' ) return [];

		var numFeatures = features.length;
		for( var i = 0; i < numFeatures; i++ )
		{
			var feature = features[i];
			if( feature.data.shouldShowOnFeedPlus )
			{
				feedPlusFeatures.push(feature);
			}
		}

		return feedPlusFeatures;
	},

  getPassHomeFeatures: function()
	{
		var feedPlusFeatures = [];
    var features = this.getFeatures();
		if( typeof features === 'undefined' ) return [];

		var numFeatures = features.length;
		for( var i = 0; i < numFeatures; i++ )
		{
			var feature = features[i];
			if( feature.data.shouldShowOnFeedPlus )
			{
				feedPlusFeatures.push(feature);
			}
		}

		return feedPlusFeatures;
	},

  getFeedFeatureNames: function()
  {
    var feedFeatures = this.getFeedFeatures();
    var feedFeatureNames = [];
    for( var i = 0; i < feedFeatures.length; i++ )
    {
      var feedFeature = feedFeatures[i];
      feedFeatureNames.push(feedFeature.key);
    }

    return feedFeatureNames;
  },

	getFeatureForName: function(featureName)
	{
    if( featureName == "Refunds" )
    {
      return {
        data:{
            title:"Refunds",
            requiresLogin:false,
            icon:"pencil"
          },
        key:"Refunds"}
    }
    
		return this.getFeatureDict()[featureName];
	},

  getFeatureOverrideForName: function(featureName, extras)
  {
    if( featureName == "Rewards" )
    {
      var rewardsCampaignsFeature = this.getFeatureForName("RewardsCampaigns");
      if( typeof rewardsCampaignsFeature !== 'undefined' )
      {
        featureName = "RewardsCampaigns";
      }
    }
    if( featureName == "EarnPoints" )
    {
      var rewardsCampaignsFeature = this.getFeatureForName("RewardsCampaigns");
      if( typeof rewardsCampaignsFeature !== 'undefined' )
      {
        featureName = "RewardsCampaigns";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showEarnPointsFirst = true;
      }
    }
    if( featureName == "CheckIn" )
    {
      var earnPayFeature = this.getFeatureForName("EarnPay");
      if( typeof earnPayFeature !== 'undefined' )
      {
        featureName = "EarnPay";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showCheckInFirst = true;
      }
    }
    if( featureName == "UseCredit" )
    {
      var earnPayFeature = this.getFeatureForName("EarnPay");
      if( typeof earnPayFeature !== 'undefined' )
      {
        featureName = "EarnPay";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showUseCreditFirst = true;
      }
    }

    return {featureName, extras};
  },

  getPrerequisiteFeatureForName: function(featureName)
  {
    if( featureName == "AddCredit" || featureName == "SendGiftCard" || featureName == "AddPass" )
    {
      var paymentTypesFeature = this.getFeatureForName("PaymentTypes");
      if( typeof paymentTypesFeature !== 'undefined' )
      {
        var hasPrimaryPaymentMethod = this.userHasPrimaryPaymentMethod();
        if( !hasPrimaryPaymentMethod ) return paymentTypesFeature;
      }

      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
      if( typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForPurchase] )
      {
        var hasPhoneNumber = this.userHasPhoneNumber();
        if( !hasPhoneNumber ) return phoneNumberVerifyFeature;
      }
    }
    else if( featureName == "PaymentTypes" )
    {
      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
      if( typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForPaymentTypes] )
      {
        var hasPhoneNumber = this.userHasPhoneNumber();
        if( !hasPhoneNumber ) return phoneNumberVerifyFeature;
      }
    }
    else if( featureName == "UseReward" || featureName == "UsePass" )
    {
      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
      if( typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForRewards] )
      {
        var hasPhoneNumber = this.userHasPhoneNumber();
        if( !hasPhoneNumber ) return phoneNumberVerifyFeature;
      }
    }
    else if( featureName == "UseCredit" )
    {
      if( this.isLoggedIn() )
      {
        var userHasCredit = this.currentUser()[ModelConstants.Credits] > 0;
        var userHasPrimaryPaymentMethod = this.userHasPrimaryPaymentMethod();
        if( !userHasCredit && !userHasPrimaryPaymentMethod )
        {
          var paymentTypesFeature = this.getFeatureForName("PaymentTypes");
          if( typeof paymentTypesFeature !== 'undefined' ) return paymentTypesFeature;
        }

        var isLivePay = this.currentUser()[ModelConstants.PayMode] == 1;
        if( !userHasCredit && !isLivePay && userHasPrimaryPaymentMethod )
        {
          var addCreditFeature = this.getFeatureForName("AddCredit");
          if( typeof addCreditFeature !== 'undefined' ) return addCreditFeature;
        }
      }
    }

		return null;
  },

  userHasPrimaryPaymentMethod: function()
  {
    var paymentInfo = this.getPaymentInfo();
    var hasPrimaryPaymentMethod = false;
    for( var i = 0; i < paymentInfo.length; i++ )
    {
      if( paymentInfo[i].isPrimary )
      {
        hasPrimaryPaymentMethod = true;
        break;
      }
    }

    return hasPrimaryPaymentMethod;
  },

  userHasPhoneNumber: function()
  {
    if( !this.isLoggedIn() ) return false;

    var phoneNumber = this.currentUser()[ModelConstants.PhoneNumber];

    return typeof phoneNumber !== 'undefined' && phoneNumber != null;
  },

  userRequiresPostalCode: function()
  {
    if( !this.isLoggedIn() ) return false;

    return typeof this.currentUser()[ModelConstants.RequirePostalCode] !== 'undefined' && this.currentUser()[ModelConstants.RequirePostalCode];
  },

  _domain : "",
  getServerURL: function()
	{
    if( Platform.OS == 'web' )
    {
      var hostname = window.location.hostname;
      if( typeof hostname !== 'undefined' )
      {
        if( hostname.indexOf(".dev.") >= 0 || hostname.indexOf("localhost") >= 0 )
        {
          this._appData["Header"]["APIBaseURL"] = "https://api.dev.getreup.com/client/";
        }
        else if( hostname.indexOf(".stage.") >= 0 )
        {
          this._appData["Header"]["APIBaseURL"] = "https://api.stage.getreup.com/client/";
        }
        else if( hostname.indexOf(".feature01.") >= 0 )
        {
          this._appData["Header"]["APIBaseURL"] = "https://api.feature01.getreup.com/client/";
        }
        else if( hostname.indexOf(".feature02.") >= 0 )
        {
          this._appData["Header"]["APIBaseURL"] = "https://api.feature02.getreup.com/client/";
        }
      }
    }

    //console.log("config: " + JSON.stringify(this._appData));
    if( this._domain.length > 0 )
    {
      return this._appData["Header"]["APIBaseURL"] + this._appData["Header"]["APIVersion"] + "/" + this._domain;
      // https://dev.getreup.com/scanner/VX.Y/reupdemo/?hash=3761e6d58b358892d76768bc981bc940
    }

		return this._appData["Header"]["APIBaseURL"] + this._appData["Header"]["APIVersion"] + "/" + this._appData["Header"]["AppID"];
		// return this.state.data["Header"]["APIBaseURL-DEBUG"] + this.state.data["Header"]["APIVersion"] + "/" + this.state.data["Header"]["AppID"];
	},

  getTermsLink: function()
  {
    var environment = "";
    var apiURL = this._appData["Header"]["APIBaseURL"];
    var tosLink = apiURL.replace("/client/", "/misc/") + 'app_tc.php?appid=' + this._appData["Header"].AppID + '&appname=' + encodeURI(this.appNameLong);;

    return tosLink;
  },

  getStripeElementsURL: function()
  {
    var baseURL = "https://api.getreup.com/misc/stripeElements.php";
    if( this._appData["Header"]["APIBaseURL"].indexOf(".dev.") >= 0 ) baseURL = "https://api.dev.getreup.com/misc/stripeElements.php";
    if( this._appData["Header"]["APIBaseURL"].indexOf(".stage.") >= 0 ) baseURL = "https://api.stage.getreup.com/misc/stripeElements.php";
    if( this._appData["Header"]["APIBaseURL"].indexOf(".feature01.") >= 0 ) baseURL = "https://api.feature02.getreup.com/misc/stripeElements.php";
    if( this._appData["Header"]["APIBaseURL"].indexOf(".feature02.") >= 0 ) baseURL = "https://api.feature02.getreup.com/misc/stripeElements.php";

    var locale = "en";
    var token = "";
    var deviceInfo = this.getDeviceInfo();
    if( typeof deviceInfo.locale !== 'undefined' && deviceInfo.locale != null && deviceInfo.locale.length > 0 )
    {
      locale = ((deviceInfo.locale.split("-")[0]).split("_")[0]).toLowerCase();
    }
    if( this.isLoggedIn() )
    {
      token = this.currentUser()[ModelConstants.StripeKey];
    }

    return baseURL+"?locale="+locale+"&token="+token;
  },

  // this version doesn't go to the db
  _currentUser: DEFAULT_USER,
  currentUser: function()
  {
    return this._currentUser;
  },

  // temp user/pass
  getTempUserPass: function(completion)
  {
    AppManager.getVariable("tempuserpass", function(value)
    {
      if( value && value != null )
      {
        completion(JSON.parse(value))
      }
      else
      {
        completion(null);
      }
    });
  },

  setTempUserPass: function(userPassArray, completion)
  {
    var userPassStr = JSON.stringify(userPassArray);
    this.setVariable("tempuserpass", userPassStr, completion);
  },

  getLastDomainEmail: function(completion)
  {
    this.getVariable("lastdomainemail", function(value)
    {
      if( value && value != null )
      {
        completion(JSON.parse(value))
      }
      else
      {
        completion(null);
      }
    });
  },

  setLastDomainEmail: function(domainEmailArray, completion)
  {
    var domainEmailArrayStr = JSON.stringify(domainEmailArray);
    this.setVariable("lastdomainemail", domainEmailArrayStr, completion);
  },

  _hasSelfie: false,
  getSelfie: function(completion)
  {
    if( !this.isLoggedIn() )
    {
      this._hasSelfie = false;
      completion(null);
      return;
    }
    var thisThing = this;
    var user = this._currentUser;
    var selfieName = user[ModelConstants.UserName] + "-selfie";
    this.getVariable(selfieName, function(data)
    {
      thisThing._hasSelfie = data != null;
      if( data != null && typeof data !== 'undefined' && typeof data.path !== 'undefined' ) data = data.path;
      if( completion ) completion(data);
    });
  },

  setSelfie: function(selfieURL, completion)
  {
    if( typeof selfieURL.path !== 'undefined' ) selfieURL = selfieURL.path;

    if( !this.isLoggedIn() )
    {
      completion(null);
      return;
    }
    var thisThing = this;
    var user = this._currentUser;
    var selfieName = user[ModelConstants.UserName] + "-selfie";
    this.getSelfie(function(oldURL)
    {
      if( oldURL && oldURL != null )
      {
        RNFS.unlink(selfieName);
      }
      selfieURL = selfieURL.replace(/file\:\/\//g, '');
      thisThing.encodeImageFileAsBase64(selfieURL, function(base64image)
      {
        thisThing.setVariable(selfieName, "data:image/png;base64,"+base64image, function()
        {
          if( typeof completion !== 'undefined' ) completion();
          thisThing._eventEmitter.emit("dbUpdated", {});
        });
      })
    })
  },

  encodeImageFileAsBase64: function(url, completion)
  {
    try {
      RNFS.readFile(url, 'base64')
      .then(response =>
      {
        if( completion ) completion(response);
      })
      .catch(e =>
      {
        console.log("ERRRRRORB", e)
      });

    } catch (e) {
      console.log("ERRRRROR", e)
    } finally {

    }
  },

  getVariable: function(varName, completion)
  {
    this._varTable.get(varName, (obj)=>
    {
      completion(obj == null ? null : obj.value)
    });
  },

  setVariable: function(varName, varValue, completion)
  {
    this._varTable.set({key:varName, value:varValue}, completion);
  },

  _SOFT_UPDATE_REPOST_SECONDS:1*24*60*60,
  _SOFT_UPDATE_ALERT_DATE: "SOFT_UPDATE_ALERT_DATE",
  shouldSoftUpdateAlert: function(completion)
  {
    var appManager = this;
    this.getVariable(this._SOFT_UPDATE_ALERT_DATE, function(variable)
    {
      var nowSeconds = new Date().getTime() / 1000;
      if( (parseInt(variable) + appManager._SOFT_UPDATE_REPOST_SECONDS) > nowSeconds )
      {
        completion(false);
      }
      else
      {
        appManager.setVariable(appManager._SOFT_UPDATE_ALERT_DATE, nowSeconds + "", function()
        {
          completion(true);
        })
      }
    });
  },

  currentUserInitials: function()
  {
    if( this._currentUser && this._currentUser[ModelConstants.FirstName] && this._currentUser[ModelConstants.LastName] )
    var firstName = this._currentUser[ModelConstants.FirstName];
    if( typeof firstName === 'undefined' ) return "";
    var firstInitial = firstName.length > 0 ? firstName.substring(0,1).toUpperCase() : "";

    var lastName = this._currentUser[ModelConstants.LastName];
    var lastInitial = lastName.length > 0 ? lastName.substring(0,1).toUpperCase() : "";

    return firstInitial + lastInitial;
  },

  currentUserFullName: function()
  {
    var firstName = null;
    if( this._currentUser && this._currentUser[ModelConstants.FirstName] && this._currentUser[ModelConstants.LastName] )
    {
      firstName = this._currentUser[ModelConstants.FirstName];
    }
    if( typeof firstName === 'undefined' || firstName == null ) return "";

    return firstName + " " + this._currentUser[ModelConstants.LastName];
  },

	getCurrentUser: function(completion)
	{
    var appManager = this;
    if( appManager._currentUser != null )
    {
      if( completion) completion(appManager._currentUser);
      return;
    }

    DB.table("Users").get_all(function(data)
    {
      var users = data.rows;
      for( var key in users )
      {
        appManager._currentUser = users[key];
        if( completion ) completion(users[key]);
        return;
      }
      appManager._currentUser = null;
      if( completion ) completion(null);
    });
	},

  setCurrentUser: function(newUser, completion)
  {
    // if( completion ) completion(this._currentUser);
    // return;

    if( newUser != null )
    {
      var appMan = this;
      this.setTempUserPass([]);
      this.getCurrentUser(function(user)
      {
        // if the user exists,
        //   check if its the same username
        //     if its the same username, use the old password, unless there is a new password
        //   delete the table with the old user
        //   add the new user
        // if the user doesn't exist, just add the new user
        var newUserName = newUser[ModelConstants.UserName];
        if( user != null && (user[ModelConstants.UserName] == newUserName || user[ModelConstants.UserName].toLowerCase() == newUserName.toLowerCase()) )
        {
          var oldUserName = user[ModelConstants.UserName];
          var oldPassword = user[ModelConstants.Password];
          var newPassword = newUser[ModelConstants.Password];
          if( (newUserName == oldUserName || newUserName.toLowerCase() == oldUserName.toLowerCase()) && (typeof newPassword === 'undefined' || newPassword == null || newPassword.length <= 0) )
          {
            newUser[ModelConstants.Password] = oldPassword;
          }
          DB.table("Users").update({UserName: newUserName}, newUser, function(updated_table)
          {
            appMan._currentUser = newUser;
            appMan._eventEmitter.emit("dbUpdated", {});
            appMan._eventEmitter.emit("checkUserChanged", {});
            if( completion ) completion(newUser);
          })
        }
        else if( user == null )
        {
          DB.table("Users").add(newUser, function()
          {
            if( typeof newUser.Currency !== 'undefined' ) appMan.setCurrency(newUser.Currency);
            appMan._currentUser = newUser;
            appMan._eventEmitter.emit("dbUpdated", {});
            appMan._eventEmitter.emit("checkUserChanged", {});
            if( typeof appMan.loginCallBack !== 'undefined' ) appMan.loginCallBack();
            if( completion ) completion(newUser);
          });
        }
        else if( user[ModelConstants.UserName] != newUserName )
        {
          DB.table("Users").erase_db(function(removed_data)
          {
            var newPassword = newUser[ModelConstants.Password];
            if( typeof newPassword === 'undefined' || newPassword == null || newPassword.length <= 0 )
            {
              // something wrong, log out
              appMan._eventEmitter.emit("dbUpdated", {});
              appMan._eventEmitter.emit("checkUserChanged", {});
              appMan.logout(completion);
            }
            else
            {
              DB.table("Users").add(newUser, function()
              {
                appMan._currentUser = newUser;
                appMan._eventEmitter.emit("dbUpdated", {});
                appMan._eventEmitter.emit("checkUserChanged", {});
                if( completion ) completion(newUser);
              });
            }
          });
        }
      });
    }
    else
    {
      var appMan = this;
      DB.table("Users").erase_db(function(removed_data)
      {
        appMan._currentUser = null;
        appMan._eventEmitter.emit("dbUpdated", {});
        appMan._eventEmitter.emit("checkUserChanged", {});
        if( completion ) completion(newUser);
      })
    }
  },

  getPaymentInfo : function()
  {
    var paymentInfoObject = [];
    try {
      paymentInfoObject = JSON.parse(this.currentUser()[ModelConstants.PaymentInfo]);
      if( paymentInfoObject == null ) paymentInfoObject = [];
    } catch (e) {
      return [];
    } finally {
      return paymentInfoObject;
    }
  },

  setPaymentInfo : function(paymentInfo, completion)
  {
    var thisThing = this;
    this.getCurrentUser(function(user)
    {
      if( !user )
      {
        completion(null);
      }
      else
      {
        user[ModelConstants.PaymentInfo] = paymentInfo;
        thisThing.setCurrentUser(user, function()
        {
          completion(user);
        })
      }
    })
  },

  _didDownloadPass : false,
  _downloadCounter : 0,
  getPassURL : function()
  {
    if( !this.isLoggedIn() ) return null;
    if( Platform.OS == 'ios' )
    {
      var serverURL = this.getServerURL();
      var baseURL = "https://api.getreup.com/misc/generate_pass.php";
      if( serverURL.indexOf(".dev.") >= 0 )
      {
        baseURL = "https://api.dev.getreup.com/misc/generate_pass.php";
      }
      else if( serverURL.indexOf(".stage.") >= 0 )
      {
        baseURL = "https://api.stage.getreup.com/misc/generate_pass.php";
      }
      else if( serverURL.indexOf(".feature01.") >= 0 )
      {
        baseURL = "https://api.feature01.getreup.com/misc/generate_pass.php";
      }
      else if( serverURL.indexOf(".feature02.") >= 0 )
      {
        baseURL = "https://api.feature02.getreup.com/misc/generate_pass.php";
      }
      
      return baseURL+"?appid="+this._appData["Header"]["AppID"]+"&userid="+this.currentUser()[ModelConstants.UserID]+"&hash="+this.currentUser()[ModelConstants.Hash]+"&n="+this._downloadCounter;      
    }

    return null;
  },

  getSupportEmail : function()
  {
    if( this.isLoggedIn() )
    {
      var user = this.currentUser();
      if( typeof user[ModelConstants.SupportEmail] !== 'undefined' ) return user[ModelConstants.SupportEmail];

      return "support+"+this._appData["Header"]["AppID"]+"-"+user[ModelConstants.UserID]+"-"+Platform.OS+"@getreup.com";
    }

    return "support@getreup.com";
  },

  _currentPosition: {latitude:0, longitude:0},
  getCurrentPosition: function()
  {
    return this._currentPosition;
  },

  hasCurrentPosition: function()
  {
    return typeof this._currentPosition !== 'undefined' && this._currentPosition.latitude != 0 && this._currentPosition.longitude != 0;
  },

  updateCurrentPosition: function(completion)
  {
    if(findGetParameter("isPass") == "1" || findGetParameter("isPassFree") == "1" || findGetParameter("isPassPro") == "1" )
    {
      // completion()
      return;
    }
    var thisThing = this;
    if( this.SKIP_TUTORIAL )
    {
      thisThing._currentPosition = {
        latitude: parseFloat(49.504741),
        longitude: parseFloat(-122.102057),
      }
      if( completion ) completion(thisThing._currentPosition);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) =>
      {
        thisThing._currentPosition = {
          latitude: parseFloat(position.coords.latitude),
          longitude: parseFloat(position.coords.longitude),
        }

        if( completion ) completion(thisThing._currentPosition);
      },
      (error) => console.log(JSON.stringify(error)),
      {enableHighAccuracy: false, timeout: 10000, maximumAge: 3000}
    );
  },

	logout: function(completion)
	{
    var thisThing = this;
    this._updatedFeatures = {};
    this.setCurrentUser(null, function()
    {
      var finalCompletion = function()
      {
        thisThing.setData({Transactions:[]}, completion);
      };
      NetworkManager.update(thisThing,[],finalCompletion,finalCompletion);
    });
	},

	isLoggedIn: function()
	{
		return this._currentUser != null && this._currentUser[ModelConstants.UserName] != null && this._currentUser[ModelConstants.Password] != null;
	},

	useFacebookForFeatureName: function(featureName)
	{
    var feature = this.getFeatureForName(featureName);
    if( typeof feature === 'undefined' ) return false;
    if( typeof feature.data.useFacebook === 'undefined' ) return false;

    return feature.data.useFacebook;
	},

  isValidPassword: function(pass)
  {
    return pass.length >= 8;
  },

  isValidEmail: function(email)
  {
    if( !((email.indexOf("@") > -1) && (email.indexOf(".") > -1)) ) return false;
    if( email.trim().indexOf(" ") > -1 ) return false;

    return true;
  },

  parseName: function(fullName)
  {
    var names = fullName.trim().split(" ");
    var lastName = names[names.length-1];
    var firstName = "";
    for( var i = 0; i < names.length-1; i++ )
    {
      if( firstName.length > 0 ) firstName += " ";
      firstName += names[i];
    }

    return {firstName:firstName, lastName:lastName};
  },

  isNameValid: function(fullName)
  {
    var {firstName, lastName} = this.parseName(fullName);

    return firstName.length > 0 && lastName.length > 0;
  },

  isAdminLoggedIn : function()
  {
    return false;
  },

  getAppInfo: function()
	{
    if( this._appData["Header"]["AppID"] == "00000" ) return {};

		return { appid: this._appData["Header"]["AppID"], appversion: BundleVersion, configversion: this._appData["Header"]["ConfigVersion"], "platform": Platform.OS};
	},

  _deviceInfo: {},
  setDeviceInfo: function(deviceInfo)
  {
    if( typeof deviceInfo === 'undefined' || deviceInfo == null ) return;

    if( typeof deviceInfo.installationId !== 'undefined' )
    {
      var thisThing = this;
      this._deviceInfo.installationID = deviceInfo.installationId;
      this.setVariable('installationID', deviceInfo.installationId, function()
      {
        if( typeof deviceInfo.deviceType !== 'undefined' )
        {
          thisThing._deviceInfo.deviceType = deviceInfo.deviceType;
          thisThing.setVariable('deviceType', deviceInfo.deviceType, function(){});
        }
      });
    }
  },

  syncDeviceInfo: function()
  {
    var thisThing = this;


    this.getVariable('deviceType', function(deviceType)
    {
      if( typeof deviceType !== 'undefined' && deviceType != null )
      {
        thisThing._deviceInfo.deviceType = deviceType;
      }

      thisThing.getVariable('installationID', function(installationID)
      {
        if( typeof installationID !== 'undefined' && installationID != null )
        {
          thisThing._deviceInfo.installationID = installationID;
        }
      })
    })
  },

  getDeviceInfo: function()
  {
    var currentPosition = this.getCurrentPosition();
    if( typeof currentPosition.longitude !== 'undefined' && currentPosition.longitude != 0
      && typeof currentPosition.latitude !== 'undefined' && currentPosition.latitude != 0 )
    {
      this._deviceInfo.locationInfo = currentPosition;
    }

    if( typeof this._deviceInfo.locale === 'undefined' )
    {
      if( Platform.OS != 'web' ) this._deviceInfo.locale = DeviceInfo.getDeviceLocale();
      else this._deviceInfo.locale = (window.navigator.userLanguage || window.navigator.language);
    }

    this._deviceInfo.tz = (new Date()).getTimezoneOffset();

    return this._deviceInfo;
  },

	getConfigFeatures: function()
	{
		return this.getFeatures();
	},

  _THRESHOLD_TO_REUPDATE_SECONDS:4,
  _updatedFeatures:{},
  hasUpdatedFeatureName: function(featureName)
  {
    var secondsNow = (new Date()).getTime()/1000;
    if( typeof this._updatedFeatures[featureName] === 'undefined' ||
        ((secondsNow - this._updatedFeatures[featureName]) > this._THRESHOLD_TO_REUPDATE_SECONDS) )
    {
      this._updatedFeatures[featureName] = secondsNow;
      return false;
    }

    return true;
  },

	setColorDictionary: function(colorDictionary)
	{
    this._appData.ColorDictionary = colorDictionary;
	},

  hexToRgb: function(hex)
  {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
          return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
      } : null;
  },

  getColorForKey: function(colorKey, alpha)
  {
    var color = this._appData.ColorDictionary[colorKey];
    var hex = color[0];
    if( typeof hex === 'undefined' ) hex = color["0"];
    if( typeof alpha === 'undefined' ) alpha = color[1];
    if( typeof hex === 'undefined' ) alpha = color["1"];

    hex = hex + "";
    if( hex.length == 3 ) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    if( hex.length == 1 ) hex = hex + hex + hex + hex + hex + hex;
    var rgb = AppManager.hexToRgb(hex);
    if( rgb == null || typeof rgb === 'undefined' )
    {
      alert("color for key missing: " + colorKey)
      return "";
    }

    return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + alpha + ")";
  },

  getLocalizationManager: function()
  {
    LocalizationManager.setAppManager(this);
    LocalizationManager._defaultCurrency = this._defaultCurrency;
    if( typeof _appData !== 'undefined' ) LocalizationManager._defaultDistance = typeof this._appData.Header.defaultDistance !== 'undefined' ? this._appData.Header.defaultDistance : "meters";
    if( this.isLoggedIn() && typeof this.currentUser()[ModelConstants.DefaultDistance] !== 'undefined' ) LocalizationManager._defaultDistance = this.currentUser()[ModelConstants.DefaultDistance];
    var locale = (Platform.OS == "web" ? (window.navigator.userLanguage || window.navigator.language) : this.getDeviceInfo().locale);
    LocalizationManager._defaultTime = locale.indexOf("fr-") === 0 ? "24" : "12";

    return LocalizationManager;
  },

  getDataType: function(dataType, completion)
  {
    if( typeof this.getCacheData(dataType) !== 'undefined' && this.getCacheData(dataType).length > 0 )
    {
      if( completion ) completion(this.getCacheData(dataType));
      return;
    }

    if( dataType == "Auphan" || dataType == "OrderAhead" )
    {
      this._auphanTable.getAll(function(rows)
      {
        if( completion ) completion(rows)
      })
      return;
    }

    DB.table(dataType).get_all(function(data)
    {
      var data = data.rows;
      var retData = [];
      for( var rowID in data )
      {
        if( dataType == "Twitter" || dataType == "Facebook" || dataType == "Instagram" )
        {
          try {
            if( typeof data[rowID].objstring !== 'undefined' )
            {
              var object = JSON.parse(data[rowID].objstring);
              retData.push(object);
            }
            else
            {
              retData.push(data[rowID]);
            }
          } catch (e) {

          } finally {

          }
        }
        else
        {
          retData.push(data[rowID]);
        }
      }
      if( completion ) completion(retData);
    });
  },

  getDataTypes: function(dataTypes, completion, retData, index)
  {
    index = typeof index === 'undefined' ? 0 : index;
    retData = typeof retData === 'undefined' ? {} : retData;
    if( index >= dataTypes.length )
    {
      if( completion ) completion(retData);
      return;
    }

    var thisThing = this;
    var dataType = dataTypes[index];

    this.getDataType(dataType, function(data)
    {
      retData[dataType] = data;
      thisThing.getDataTypes(dataTypes, completion, retData, index+1);
    })
  },

  setData: function(newData, completion, makeCopy)
  {
    if( typeof makeCopy === 'undefined' ) makeCopy = true;

    var updatedNewData = newData;
    if( makeCopy ) updatedNewData = JSON.parse(JSON.stringify(newData));

    this.setDataRecursive(updatedNewData, 0, completion);
  },

  setDataRecursive: function(newData, index, completion, keys)
  {
    if( typeof keys == 'undefined' ) keys = Object.keys(newData);

    if( index >= keys.length )
    {
      this._eventEmitter.emit("dbUpdated", newData);
      if( typeof completion !== 'undefined' ) completion();

      return;
    }
    var appMan = this;
    var dataType = keys[index];
    if( dataType == "Users" )
    {
      var objects = newData[dataType];
      if( objects.length > 0 )
      {
        appMan.setCurrentUser(objects[0],function()
        {
          appMan.setDataRecursive(newData, index+1, completion, keys);
        });
      }
      else
      {
        appMan.logout(function()
        {
          appMan.setDataRecursive(newData, index+1, completion, keys);
        });
      }
    }
    else if( dataType == "Auphan" || dataType == "OrderAhead" )
    {
      appMan._auphanTable.setRows(newData[dataType], function()
      {
        appMan.setDataRecursive(newData, index+1, completion, keys);
      })
    }
    else if( dataType == "Twitter" || dataType == "Facebook" || dataType == "Instagram" )
    {
      var objects = newData[dataType];
      if( objects != null && typeof objects !== 'undefined' )
      {
        appMan.setCacheData(dataType, objects);
        var objectStrings = [];
        if( objects != null )
        {
          for( var i = 0; i < objects.length; i++ )
          {
            var object = objects[i];
            try
            {
              var objectString = JSON.stringify(object);
              objectStrings.push({objstring:objectString});
            } catch (e) {
            } finally {
            }
          }
        }
        DB.table(dataType).erase_db(function(removed_data)
        {
          appMan.addObjectsOfTypeRecursive(objectStrings, dataType, 0, function()
          {
            appMan.setCacheData(dataType, []);
            appMan.setDataRecursive(newData, index+1, completion, keys);
          }, false);
        })
      }
      else
      {
        appMan.setDataRecursive(newData, index+1, completion, keys);
      }
    }
    else
    {
      if( dataType != null )
      {
        var objects = JSON.parse(JSON.stringify(newData[dataType]));
        if( objects == null )
        {
          objects = []
        }
        appMan.setCacheData(dataType, objects);

        DB.table(dataType).erase_db(function(removed_data)
        {
          appMan.addObjectsOfTypeRecursive(objects, dataType, 0, function()
          {
            appMan.setCacheData(dataType, []);
            appMan.setDataRecursive(newData, index+1, completion, keys);
          }, false);
        })
      }
      else
      {
        appMan.setDataRecursive(newData, index+1, completion, keys);
      }
    }
  },

  addObjectsOfTypeRecursive: function(objects, dataType, index, completion, cache)
  {
    if( typeof cache === 'undefined' ) cache = true;
    if( index >= objects.length )
    {
      if( typeof completion !== 'undefined' ) completion();

      return;
    }

    var appMan = this;
    if( dataType == "Users" || dataType == "User" )
    {
      if( typeof objects.UserID !== 'undefined' )
      {
        // not an array, just use this
        appMan.setCurrentUser(objects, function()
        {
          if( typeof completion !== 'undefined' ) completion();
        })
      }
      else
      {
        appMan.setCurrentUser(objects[0], function()
        {
          if( typeof completion !== 'undefined' ) completion();
        })
      }
    }
    else
    {
      // putting in batch add
      if( cache )
      {
        for( var i = 0; i < objects.length; i++ )
        {
          appMan.addCacheData(dataType, objects[i]);
        }
      }

      DB.table(dataType).add_all(objects, ()=>
      {
        if( cache ) appMan.setCacheData(dataType, []);
        completion();
      })
      // DB.table(dataType).add(objects[index], function()
      // {
      //   appMan.addObjectsOfTypeRecursive(objects, dataType, index+1, completion);
      // })
    }
  },

  _cachedData: {},
  setCacheData(dataType, data)
  {
    if( typeof data !== 'undefined' && data != null && typeof data.slice !== 'undefined' ) this._cachedData[dataType] = data.slice(0,100);
  },

  addCacheData(dataType, data)
  {
    this.getCacheData(dataType).push(data);
  },

  getCacheData(dataType)
  {
    if( typeof this._cachedData[dataType] == 'undefined' ) this._cachedData[dataType] = [];

    return JSON.parse(JSON.stringify(this._cachedData[dataType]));
  },

  getTime: function(dateString)
  {
    if( typeof dateString === 'undefined' ) return 0;
    var find = "-";
    var re = new RegExp(find, 'g');
    var newDateString = dateString.replace(re, '/');
    var date = new Date(newDateString);

    return date.getTime();
  },

  _lastUpdatedDates: {},
  getTimeSinceLastUpdateOfFeatureName: function(featureName)
  {
    if( typeof this._lastUpdatedDates[featureName] === 'undefined' ) return Number.MAX_VALUE;

    return (new Date()).getTime() - this._lastUpdatedDates[featureName].getTime();
  },

  setUpdatedDateOfFeatureName: function(featureName)
  {
    this._lastUpdatedDates[featureName] = new Date();
  },

  timeSince: function(date, addAgo)
  {
    if( typeof addAgo === 'undefined' ) addAgo = true;

    var seconds = 0;
    if( isNaN(date) && typeof date !== 'object' )
    {
      seconds = Math.abs(parseInt(date));
    }
    else
    {
      if (typeof date !== 'object')
      {
        var find = "-";
        var re = new RegExp(find, 'g');
        var newDateString = date.replace(re, '/');
        var date = new Date(newDateString);
        date = new Date(date);
      }
      seconds = Math.abs(Math.floor(((new Date()).getTime() - date.getTime()) / 1000));
    }

    if( addAgo ) return this.getLocalizationManager().localizedLongDate(seconds*1000);

    return this.getLocalizationManager().localizedLongDateFuture(seconds*1000);
  },

  timeTill: function(seconds)
  {
    return this.getLocalizationManager().localizedLongDateFuture(seconds*1000);
  },
}

module.exports = AppManager;



// WEBPACK FOOTER //
// ./src/appManager.js